// extracted by mini-css-extract-plugin
export default {"messenger":"messenger_messenger__RvQTi","menu":"messenger_menu__DXTn+","selection":"messenger_selection__W89SQ"};